import { Component } from '@angular/core';

@Component({
    template: `<router-outlet></router-outlet>`
})
export class AuthComponent {
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/auth/auth.component.ts